export const appThemeTokens = {
  palette: {
    mode: 'light',
    primary: {
      main: '#1A1A1A',
      light: '#4A4A4A',
      dark: '#000000',
      50: '#F5F5F5',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#4F46E5',
      light: '#818CF8',
      dark: '#3730A3',
      50: '#EEF2FF',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#0D7C5F',
      light: '#48BB98',
      dark: '#085D45',
      50: '#E6F7F1',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#C53030',
      light: '#E56767',
      dark: '#9B2C2C',
      50: '#FEF2F2',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#7C3AED',
      light: '#A78BFA',
      dark: '#5B21B6',
      50: '#F5F3FF',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#2563EB',
      light: '#60A5FA',
      dark: '#1E40AF',
      50: '#EFF6FF',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FAFAF8',
      paper: '#FFFFFF',
    },
    status: {
      new: '#17a2b8',
      saved: '#6c757d',
      applied: '#007bff',
      screening: '#fd7e14',
      interview: '#ffc107',
      interviewed: '#20c997',
      offer: '#28a745',
      negotiating: '#6f42c1',
      accepted: '#28a745',
      rejected: '#dc3545',
      withdrawn: '#6c757d',
    },
    text: {
      primary: '#1A1A1A',
      secondary: '#717171',
    },
    grey: {
      50: '#F3F4F6',
      100: '#E8E8E8',
      200: '#D1D5DB',
      300: '#B0B0B0',
      400: '#9CA3AF',
      500: '#717171',
      700: '#4A4A4A',
      900: '#2D2D2D',
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
      letterSpacing: '-0.025em',
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 700,
      letterSpacing: '-0.025em',
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 700,
      letterSpacing: '-0.025em',
      lineHeight: 1.2,
    },
    h4: {
      fontSize: '1.125rem',
      fontWeight: 700,
      letterSpacing: '-0.025em',
      lineHeight: 1.2,
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 700,
      letterSpacing: '-0.025em',
      lineHeight: 1.2,
    },
    h6: {
      fontSize: '0.875rem',
      fontWeight: 700,
      letterSpacing: '-0.025em',
      lineHeight: 1.2,
    },
    body1: {
      fontSize: '0.9375rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    button: {
      fontWeight: 600,
      fontSize: '0.875rem',
      textTransform: 'none',
      letterSpacing: '0',
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 10,
  },
  shadows: [
    'none',
    '0 1px 2px rgba(0, 0, 0, 0.04)',
    '0 4px 12px rgba(0, 0, 0, 0.06)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
    '0 8px 24px rgba(0, 0, 0, 0.08)',
  ],
};

export const portalThemeBridge = {
  maxWidth: '960px',
  narrowWidth: '720px',
  legalWidth: '780px',
  radii: {
    sm: '8px',
    md: '10px',
    lg: '16px',
    pill: '999px',
  },
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.04)',
    md: '0 4px 12px rgba(0, 0, 0, 0.06)',
    lg: '0 8px 24px rgba(0, 0, 0, 0.08)',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    xxl: '2rem',
  },
};

export default appThemeTokens;
